<div class="main-content">
  <div class="container-fluid">
    <div class="row" id="loginContainer">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4 class="card-title">Login</h4>
            <p class="card-category">login to your account</p>
          </div>
          <div class="card-body">
            <ng-container *ngIf="!showOTP">
              <div class="row">
                <div class="col-md-12 space">
                  <input
                    [(ngModel)]="email"
                    matInput
                    type="email"
                    placeholder="Email"
                    (keydown)="keyDownFunction($event)"
                  />
                  <span class="text-danger">{{ emailErr }}</span>
                </div>
              </div>
              <span class="text-danger">{{ authEror }}</span>
              <span class="text-success">{{ infoMessage }}</span>
              <button
                mat-raised-button
                type="button"
                (click)="sendCode()"
                [disabled]="isSubmitting"
                class="btn btn-danger pull-right"
              >
                {{ isSubmitting ? "Sending…" : "Send Code" }}
              </button>
              <div class="clearfix"></div>
            </ng-container>

            <ng-container *ngIf="showOTP">
              <p>We've sent a 6-digit code to <strong>{{ email }}</strong>.</p>
              <div class="row">
                <div class="col-md-12 space">
                  <input
                    [(ngModel)]="code"
                    matInput
                    placeholder="Verification code"
                    (keydown)="keyDownFunction($event)"
                  />
                  <span class="text-danger">{{ codeErr }}</span>
                </div>
              </div>
              <span class="text-danger">{{ authEror }}</span>
              <span class="text-success">{{ infoMessage }}</span>
              <button
                mat-raised-button
                type="button"
                (click)="verifyCode()"
                [disabled]="isSubmitting"
                class="btn btn-danger pull-right"
              >
                {{ isSubmitting ? "Verifying…" : "Verify & Sign In" }}
              </button>
              <div class="clearfix"></div>
              <button
                mat-button
                type="button"
                (click)="resendCode()"
                [disabled]="resendAvailableInSeconds > 0"
              >
                {{ resendAvailableInSeconds > 0 ? "Resend code (" + resendAvailableInSeconds + "s)" : "Resend code" }}
              </button>
              <button mat-button type="button" (click)="changeEmail()">Use a different email</button>
            </ng-container>

            <div class="row google-signin-row">
              <div class="col-md-12 space">
                <div class="google-signin-divider"><span>or</span></div>
                <button
                  mat-stroked-button
                  type="button"
                  (click)="signInWithGoogle()"
                  [disabled]="isGoogleSigningIn"
                  class="google-signin-btn"
                >
                  <mat-icon>account_circle</mat-icon>
                  {{ isGoogleSigningIn ? "Signing in…" : "Sign in with Google" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
